export default {
    en: {
        REPORT_CARD_DIALOG_TITLE: 'CyberSafe AI Mission Log',
        REPORT_CARD_DIALOG_LOADING_MESSAGE: 'Generating your mission log...',
        REPORT_CARD_DIALOG_NAME_LABEL: 'Name:',
        REPORT_CARD_DIALOG_GENERATED_ON_LABEL: 'Generated on:',
        REPORT_CARD_DIALOG_SHARABLE_LINK_LABEL: 'Sharable Link:',
        REPORT_CARD_DIALOG_COPY_LABEL: 'Copy sharable link',
        REPORT_CARD_DIALOG_COLUMN_LEVEL: 'Mission',
        REPORT_CARD_DIALOG_COLUMN_POINTS: 'Points',
        REPORT_CARD_DIALOG_COLUMN_STATUS: 'Status',
        REPORT_CARD_DIALOG_STATUS_COMPLETED: 'Completed',
        REPORT_CARD_DIALOG_LINK_VALID_UNTIL: 'Sharable link valid until {date}.',
        REPORT_CARD_DIALOG_CLOSE: 'Close',
        REPORT_CARD_DIALOG_NO_PLAYER_ERROR: 'Your player profile could not be found, so a mission log cannot be generated.',
    }
};
